import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
    ProfilePhotoSection,
    CustomAvatar,
    UploadButton
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Checkbox } from '../../../components/checkbox'
import { useState } from 'react'
const AccountProfilePrivacy = () => {
    const [imageUploadValue, setImageUploadValue] = useState('')

    const handleImageUploadValue = (e) => {
        const file = e.target.files[0]
        setImageUploadValue(file.name)
    }
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Profile & Privacy
                        </Heading>
                        <Breadcrumb
                            crumbs={['account', 'profile & privacy']}
                        />
                        <ProfilePhotoSection>
                            <p>Your Photo</p>
                            <div className="image-input-container">
                                <div>
                                    <CustomAvatar alt="Name" src="/assets/images/account-avatar.webp" />
                                </div>
                                <div className="input-button-container">
                                    <Input value={imageUploadValue} type='text' placeholder="Choose file" style={{ height: '42px', width: '292px' }} />
                                    <label htmlFor="contained-button-file">
                                        <input onChange={handleImageUploadValue} accept="image/*" id="contained-button-file" multiple type="file" style={{ display: 'none' }} />
                                        <UploadButton variant="contained" component="span"
                                            disableElevation
                                            color="primary"
                                        >
                                            Upload
                                        </UploadButton>
                                    </label>
                                </div>
                            </div>
                        </ProfilePhotoSection>
                        <form>
                            <InputWrapper>
                                <Input
                                    id="profileName"
                                    label="KlASSCONNECT PROFILE NAME"
                                    type="text"
                                    placeholder="klasconnect.com/s/25990/profile"
                                    fullWidth
                                />
                            </InputWrapper>
                            {/* TODO: TEXTAREA */}

                            <InputWrapper>
                                <Checkbox
                                    id="realName"
                                    label="Display your real name on your profile"
                                    type="checkbox"
                                    fullWidth
                                    helperText="If unchecked, your profile name will be displayed instead of your full name."
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Checkbox
                                    id="seeProfile"
                                    label="Allow everyone to see your profile"
                                    type="checkbox"
                                    fullWidth
                                    helperText="If unchecked, your profile will be private and no one except you will be able to view it."
                                />
                            </InputWrapper>
                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto' }}
                                variant="secondary"
                                responsive
                            >
                                SAVE CHANGES
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default AccountProfilePrivacy
